// @core/api/endpoints/tenant/get_tenant_migration.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantMigrationResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get migration status
 * Returns the current status and progress of a tenant migration, including phase details and any errors.
 */
export async function GetTenantMigration(
  tenant_id: string,
  migration_id: string,
  options?: RequestOptions
): Promise<TenantMigrationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/migration/:migration_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':migration_id', encodeURIComponent(migration_id));
  const requestOptions = options;
  return client.get<TenantMigrationResponse>(requestPath, { ...requestOptions });
}
